module.exports = __webpack_public_path__ + "01f43047/img/delete-icon.eb7de062.svg";